// extracted by mini-css-extract-plugin
export default {"inputbox":"Registration_inputbox__rDqzQ","error":"Registration_error__EORRz"};